import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import connectionReducer from './connection/reducer';
import historyReducer from './history/reducer';
import uiReducer from './ui/reducer';

import { epics as historyEpics } from './history/epics';
import { epics as uiEpics } from './ui/epics';

import {
  sendWebChatReadyEpic,
  sendUserDataEpic,
  sendIsTorpedo7ClubMember
} from './connection/epics';

export const rootReducer = combineReducers({
  connection: connectionReducer,
  history: historyReducer,
  ui: uiReducer
});

export const rootEpic = combineEpics(
  ...historyEpics,
  ...uiEpics,
  sendWebChatReadyEpic,
  sendUserDataEpic,
  sendIsTorpedo7ClubMember
);



// WEBPACK FOOTER //
// ./src/reducers/index.js